



























































































































































































































































































































































































































































































































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  CUSTOMER_DETAILS,
  SET_UPDATE_CUSTOMER_SETTINGS_MODAL,
  SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SETTINGS_MODAL,
  UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS,
} from '@/types/customer.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { CubesStatusType, CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import Mock from '@/globals/backoffice.mock';
import { Utils } from '@/globals/Utils';

@Component({})
export default class CustomerSettingsComponent extends Vue {
  @Inject() public $validator: any;

  @Action(UPDATE_CUSTOMER, StoreNamespace.CUSTOMER) public updateCustomer;

  @Mutation(SET_UPDATE_CUSTOMER_SETTINGS_MODAL, StoreNamespace.CUSTOMER) public setUpdateCustomerSettingsModal;
  @Mutation(SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS, StoreNamespace.CUSTOMER)
  public setUpdateCustomerSettingsModalErrors;

  @Getter(CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public customerDetails!: CustomerDetailsModel;
  @Getter(UPDATE_CUSTOMER_SETTINGS_MODAL, StoreNamespace.CUSTOMER) public updateCustomerSettingsModal!: boolean;
  @Getter(UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS, StoreNamespace.CUSTOMER)
  public updateCustomerSettingsModalErrors!: string[];

  public customerDetailsToUpdate: CustomerDetailsModel = {} as CustomerDetailsModel;
  public customerMock: any = {};
  public ipRanges: any[] | undefined = [];
  public customerAdpMode: boolean = false;
  private CubesStatusType = CubesStatusType;

  public destroyed() {
    this.setUpdateCustomerSettingsModal(false);
  }

  public created() {
    this.setUpdateCustomerSettingsModal(false);
    this.customerDetailsToUpdate = { ...this.customerDetails };
  }

  public mounted() {
    this.customerMock = Mock.customer;
    const ipRangesList = this.customerDetails.ipToCheck?.split(',');
    this.ipRanges = ipRangesList?.map(i => i?.split('-'));
    this.ipRanges = this.ipRanges || [];
  }

  public updateCustomerSettings() {
    this.$validator.validateAll('payrollCustomerSettings').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        if (!this.customerDetailsToUpdate.activeFlag) {
          this.customerDetailsToUpdate.activeFlag = false;
        }
        if (!this.customerDetailsToUpdate.treeType) {
          this.customerDetailsToUpdate.treeType = 0;
        }
        this.customerDetailsToUpdate.officeNum = -1;
        const fixedRanges = Utils.checkIpsNotEmpty(this.ipRanges);
        if (fixedRanges.length) {
          this.customerDetailsToUpdate.ipToCheck = fixedRanges?.map(i => i.join('-')).join(',');
        } else {
          this.customerDetailsToUpdate.ipToCheck = '';
          this.ipRanges = [];
        }
        this.updateCustomer(this.customerDetailsToUpdate);
      }
    });
  }

  public onRequiredDocs(item: any) {
    if (item) {
      this.customerDetailsToUpdate.requiredDocs = item;
    }
  }

  public onCellPhoneEventSrc(event: Record<string, string>): void {
    if (event) {
      this.customerDetailsToUpdate.cellPhoneEventSrc = event.code;
      this.customerDetailsToUpdate.cellPhoneFieldNameSrc = event.event;
    }
  }

  public onEmailEventSrc(event: Record<string, string>): void {
    if (event) {
        this.customerDetailsToUpdate.emailEventSrc = event.code;
        this.customerDetailsToUpdate.emailFieldNameSrc = event.event;
      }
  }

  public empDataUpdateTypeChanged(item: any) {
    this.customerAdpMode = item === 3;
  }

  public onPensionerOfficeType(item: any) {
    if (item !== undefined) {
      this.customerDetailsToUpdate.pensionerOfficeType = item;
    }
  }

  public onInput(event: any, prop: string): void {
    if (prop) {
      this.customerDetailsToUpdate = { ...this.customerDetailsToUpdate, [prop]: event };
    }
  }

  public onCubesStatus(item: any) {
    if (item !== undefined) {
      this.customerDetailsToUpdate.cubesStatus = item;
      if (item === CubesStatusType.OFF) {
        this.customerDetailsToUpdate.activeCubeList = [];
      }
    }
  }

  public onActiveCubes(item: any) {
    if (item) {
      this.customerDetailsToUpdate.activeCubeList = item;
    }
  }

  public openUpdateCustomerSettingsModal() {
    this.setUpdateCustomerSettingsModalErrors([]);
    this.customerDetailsToUpdate = { ...this.customerDetails };
    this.setUpdateCustomerSettingsModal(true);
  }

  public closeModal() {
    this.setUpdateCustomerSettingsModal(false);
  }

  public addIpRange() {
    this.ipRanges?.push([]);
  }

  public updateIpRange(value: string[], index: any) {
    if (this.ipRanges) {
      this.ipRanges[index] = value;
    }
  }

  public deleteIpRange(index: number) {
    this.ipRanges?.splice(index, 1);
  }

  get emailEventSrc(){
    if(!this.customerDetailsToUpdate?.emailEventSrc || !this.customerDetailsToUpdate?.emailFieldNameSrc){
      return null
    }

    return {
      code: this.customerDetailsToUpdate?.emailEventSrc,
      event: this.customerDetailsToUpdate?.emailFieldNameSrc,
      description: `${this.customerDetailsToUpdate?.emailEventSrc} - ${this.customerDetailsToUpdate?.emailFieldNameSrc}`
    }
  }

  get phoneEventSrc(){
    if(!this.customerDetailsToUpdate?.cellPhoneEventSrc || !this.customerDetailsToUpdate?.cellPhoneFieldNameSrc){
      return null
    }

    return {
      code: this.customerDetailsToUpdate?.cellPhoneEventSrc,
      event: this.customerDetailsToUpdate?.cellPhoneFieldNameSrc,
      description: `${this.customerDetailsToUpdate?.cellPhoneEventSrc} - ${this.customerDetailsToUpdate?.cellPhoneFieldNameSrc}`
    }
  }
}

